import isEqual from 'lodash/isEqual'
import { type FunctionComponent, memo } from 'react'

export const memoizeTableCell = <Props>(component: FunctionComponent<Props>) =>
  memo(component, (prevProps, nextProps) => isEqual(prevProps, nextProps))
